import React from "react";
import { Phone, MessageCircle, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS } from "../data/business";

export function StickyMobileCTA() {
  return (
    <div className="sticky-mobile" data-testid="sticky-mobile-cta">
      <a href={`tel:${BUSINESS.phoneDial}`} className="flex-1 py-4 text-center text-sm font-semibold border-r border-white/10 flex items-center justify-center gap-2" data-testid="sticky-call">
        <Phone size={16} className="text-lime" /> Call
      </a>
      <a href={`https://wa.me/${BUSINESS.whatsapp}`} target="_blank" rel="noreferrer" className="flex-1 py-4 text-center text-sm font-semibold border-r border-white/10 flex items-center justify-center gap-2" data-testid="sticky-whatsapp">
        <MessageCircle size={16} className="text-lime" /> WhatsApp
      </a>
      <Link to="/quote" className="flex-1 py-4 bg-lime text-dark text-sm font-bold flex items-center justify-center gap-1" data-testid="sticky-quote">
        Free Quote <ChevronRight size={16} />
      </Link>
    </div>
  );
}

export function FloatingWhatsApp() {
  return (
    <a href={`https://wa.me/${BUSINESS.whatsapp}`} target="_blank" rel="noreferrer" className="fab-wa" aria-label="WhatsApp us" data-testid="floating-whatsapp">
      <MessageCircle size={26} />
    </a>
  );
}
